<template>
  <div class="memorial-edit-container">
    <div class="page-header">
      <el-page-header @back="goBack" :content="isEdit ? '编辑纪念' : '创建纪念'"></el-page-header>
    </div>

    <el-card shadow="never" style="margin-top: 16px;">
      <el-form ref="memorialForm" :model="formData" :rules="formRules" label-width="110px" size="medium">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="纪念标题" prop="title">
              <el-input v-model="formData.title" placeholder="请输入纪念标题" maxlength="200" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="副标题" prop="subtitle">
              <el-input v-model="formData.subtitle" placeholder="请输入副标题" maxlength="300" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="详细描述" prop="description">
              <el-input
                v-model="formData.description"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 20 }"
                placeholder="请输入详细描述"
              ></el-input>
            </el-form-item>
            <el-form-item label="获取条件说明" prop="acquireCondition">
              <el-input
                v-model="formData.acquireCondition"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder="请输入获取条件说明"
                maxlength="500"
              ></el-input>
            </el-form-item>
            <el-form-item label="使用说明" prop="usageInstruction">
              <el-input
                v-model="formData.usageInstruction"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder="请输入使用说明"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="纪念图标">
              <div class="icon-upload-area">
                <div class="icon-preview" v-if="formData.icon" @click="triggerIconUpload">
                  <el-image :src="resolveUrl(formData.icon)" fit="contain" style="width: 100%; height: 100%;"></el-image>
                  <div class="icon-overlay">
                    <i class="el-icon-upload2"></i>
                    <span>更换图标</span>
                  </div>
                </div>
                <div class="icon-placeholder" v-else @click="triggerIconUpload">
                  <i class="el-icon-plus"></i>
                  <span>上传图标</span>
                </div>
                <input type="file" ref="iconInput" style="display: none" accept="image/*" @change="handleIconUpload" />
              </div>
            </el-form-item>
            <el-form-item label="缩略图">
              <div class="icon-upload-area">
                <div class="icon-preview" v-if="formData.thumbnail" @click="triggerThumbnailUpload">
                  <el-image :src="resolveUrl(formData.thumbnail)" fit="cover" style="width: 100%; height: 100%;"></el-image>
                  <div class="icon-overlay">
                    <i class="el-icon-upload2"></i>
                    <span>更换</span>
                  </div>
                </div>
                <div class="icon-placeholder" v-else @click="triggerThumbnailUpload">
                  <i class="el-icon-plus"></i>
                  <span>上传缩略图</span>
                </div>
                <input type="file" ref="thumbnailInput" style="display: none" accept="image/*" @change="handleThumbnailUpload" />
              </div>
            </el-form-item>
            <el-form-item label="背景图">
              <div class="icon-upload-area">
                <div class="icon-preview" v-if="formData.backgroundImage" @click="triggerBgUpload">
                  <el-image :src="resolveUrl(formData.backgroundImage)" fit="cover" style="width: 100%; height: 100%;"></el-image>
                  <div class="icon-overlay">
                    <i class="el-icon-upload2"></i>
                    <span>更换</span>
                  </div>
                </div>
                <div class="icon-placeholder" v-else @click="triggerBgUpload">
                  <i class="el-icon-plus"></i>
                  <span>上传背景图</span>
                </div>
                <input type="file" ref="bgInput" style="display: none" accept="image/*" @change="handleBgUpload" />
              </div>
            </el-form-item>
            <el-form-item label="纪念系列" prop="seriesName">
              <el-select v-model="formData.seriesName" placeholder="请选择系列" style="width: 100%">
                <el-option v-for="item in seriesOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="纪念类型" prop="memorialType">
              <el-select v-model="formData.memorialType" placeholder="请选择类型" style="width: 100%">
                <el-option v-for="item in typeOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关联SKU" prop="skuId">
              <el-select
                v-model="formData.skuId"
                filterable
                placeholder="请搜索并选择SKU编码"
                :loading="skuLoading"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in skuOptions"
                  :key="item.skuId"
                  :label="item.skuId"
                  :value="item.skuId"
                >
                  <div style="display:flex;justify-content:space-between;align-items:center;">
                    <span>{{ item.skuId }}</span>
                    <span style="color:#909399;font-size:12px;margin-left:10px;">{{ item.skuName || '' }}</span>
                  </div>
                </el-option>
              </el-select>
              <div class="form-tip" style="color: #909399; font-size: 12px; line-height: 1.5; margin-top: 4px;">选择后，刷该SKU的活动卡时将自动发放此纪念</div>
            </el-form-item>
            <el-form-item label="纪念状态" prop="status">
              <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%">
                <el-option label="草稿" value="DRAFT"></el-option>
                <el-option label="已发布" value="PUBLISHED"></el-option>
                <el-option label="已过期" value="EXPIRED"></el-option>
                <el-option label="已禁用" value="DISABLED"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="打卡地点" prop="checkInLocation">
              <el-input v-model="formData.checkInLocation" placeholder="请输入打卡地点" maxlength="300"></el-input>
            </el-form-item>
            <el-form-item label="打卡时间" prop="checkInTime">
              <el-date-picker
                v-model="formData.checkInTime"
                type="datetime"
                placeholder="选择打卡时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="防伪码" prop="antiFakeCode">
              <el-input v-model="formData.antiFakeCode" placeholder="请输入衍生品防伪码" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item label="可见范围" prop="visibility">
              <el-select v-model="formData.visibility" placeholder="请选择" style="width: 100%">
                <el-option label="公开" value="PUBLIC"></el-option>
                <el-option label="私有" value="PRIVATE"></el-option>
                <el-option label="仅活动参与者" value="ACTIVITY_ONLY"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="获取权限" prop="acquirePermission">
              <el-select v-model="formData.acquirePermission" placeholder="请选择" style="width: 100%">
                <el-option label="所有人" value="ALL"></el-option>
                <el-option label="活动参与者" value="ACTIVITY_USER"></el-option>
                <el-option label="受邀用户" value="INVITED"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序序号">
              <el-input-number v-model="formData.sortOrder" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="备注信息" maxlength="500"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-footer">
          <el-button @click="goBack">取消</el-button>
          <el-button type="info" @click="handleSaveDraft" :loading="submitLoading" v-if="hasPermission('activity:memorial:save')">保存草稿</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getMemorialDetail, createMemorial, updateMemorial, uploadMemorialImage } from '@/apis/activity/memorial'
import { getDictDataByType } from '@/apis/system/dict'
import { getSkuPage } from '@/apis/product/sku'
import { hasPermission } from '@/utils/permission'
import { getFullUrl } from '@/utils'

export default {
  name: 'MemorialEdit',
  data() {
    return {
      isEdit: false,
      loading: false,
      submitLoading: false,
      seriesOptions: [],
      typeOptions: [],
      skuOptions: [],
      skuLoading: false,
      formData: {
        id: null,
        title: '',
        subtitle: '',
        icon: '',
        thumbnail: '',
        backgroundImage: '',
        seriesName: '',
        memorialType: '',
        activityId: null,
        skuId: '',
        checkInLocation: '',
        checkInTime: null,
        antiFakeCode: '',
        description: '',
        acquireCondition: '',
        usageInstruction: '',
        mediaResources: '',
        status: 'DRAFT',
        acquireStatus: 'AVAILABLE',
        visibility: 'PUBLIC',
        acquirePermission: 'ALL',
        acquireCount: 0,
        shareCount: 0,
        sortOrder: 0,
        remark: ''
      },
      formRules: {
        title: [{ required: true, message: '请输入纪念标题', trigger: 'blur' }],
        memorialType: [{ required: true, message: '请选择纪念类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadDictData()
    this.loadSkuOptions()
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      this.loadDetail(id)
    }
  },
  methods: {
    hasPermission,
    resolveUrl(url) {
      return getFullUrl(url)
    },
    loadDictData() {
      getDictDataByType('MEMORIAL_SERIES').then(res => {
        this.seriesOptions = res || []
      }).catch(e => {
        console.error('加载纪念系列字典失败:', e)
        this.seriesOptions = []
      })
      getDictDataByType('MEMORIAL_TYPE').then(res => {
        this.typeOptions = res || []
      }).catch(e => {
        console.error('加载纪念类型字典失败:', e)
        this.typeOptions = []
      })
    },
    loadSkuOptions() {
      this.skuLoading = true
      getSkuPage({ page: 1, limit: 1000 }).then(res => {
        const data = res.data || res
        this.skuOptions = Array.isArray(data.records) ? data.records : (Array.isArray(data.list) ? data.list : [])
      }).catch(e => {
        console.error('加载SKU列表失败:', e)
        this.skuOptions = []
      }).finally(() => {
        this.skuLoading = false
      })
    },
    goBack() {
      this.$router.push('/activity/memorial')
    },
    loadDetail(id) {
      this.loading = true
      getMemorialDetail(id).then(res => {
        if (res) {
          this.formData = { ...this.formData, ...res }
        }
      }).catch(e => {
        console.error('加载纪念详情失败:', e)
      }).finally(() => {
        this.loading = false
      })
    },
    triggerIconUpload() {
      this.$refs.iconInput.click()
    },
    async handleIconUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadMemorialImage(formData)
        if (res) {
          this.formData.icon = res
          this.$message.success('图标上传成功')
        }
      } catch (err) {
        this.$message.error('图标上传失败')
      }
      e.target.value = ''
    },
    triggerThumbnailUpload() {
      this.$refs.thumbnailInput.click()
    },
    async handleThumbnailUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadMemorialImage(formData)
        if (res) {
          this.formData.thumbnail = res
          this.$message.success('缩略图上传成功')
        }
      } catch (err) {
        this.$message.error('缩略图上传失败')
      }
      e.target.value = ''
    },
    triggerBgUpload() {
      this.$refs.bgInput.click()
    },
    async handleBgUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadMemorialImage(formData)
        if (res) {
          this.formData.backgroundImage = res
          this.$message.success('背景图上传成功')
        }
      } catch (err) {
        this.$message.error('背景图上传失败')
      }
      e.target.value = ''
    },
    collectFormData() {
      return { ...this.formData }
    },
    handleSaveDraft() {
      this.$refs.memorialForm.validate(valid => {
        if (!valid) return
        const data = this.collectFormData()
        data.status = 'DRAFT'
        this.submitLoading = true
        const action = this.isEdit ? updateMemorial(data) : createMemorial(data)
        action.then(() => {
          this.$message.success('保存草稿成功')
          this.goBack()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    handleSubmit() {
      this.$refs.memorialForm.validate(valid => {
        if (!valid) return
        const data = this.collectFormData()
        this.submitLoading = true
        const action = this.isEdit ? updateMemorial(data) : createMemorial(data)
        action.then(() => {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.goBack()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.memorial-edit-container {
  padding: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.icon-upload-area {
  width: 100%;
}

.icon-preview {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.icon-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
}

.icon-preview:hover .icon-overlay {
  opacity: 1;
}

.icon-placeholder {
  width: 100%;
  height: 120px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  cursor: pointer;
  transition: border-color 0.3s;
}

.icon-placeholder:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.icon-placeholder i {
  font-size: 32px;
  margin-bottom: 8px;
}

.form-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}
</style>
